import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const ScrollToTop = () => {
    const {pathname} = useLocation();
    useEffect(() => {
        if (pathname.indexOf('/p/') === -1 && pathname.indexOf('/results/') === -1) {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};
